import fetch from 'isomorphic-fetch'

import {
  FETCH_SIDEBAR_NAV_FULFILLED,
  FETCH_ALERT_CONTENT_FULFILLED
} from './types'

export function fetchSidebarNav (fromServer = false) {
  const errorMessage = 'Bad response from server'
  let url = fromServer ? 'http://127.0.0.1:3000/helpfaq-assets/static/data/' : '/helpfaq-assets/static/data/'
  return dispatch => {
    return fetch(url + 'navigation.json')
      .then(response => {
        if (response.status >= 400) {
          throw new Error(errorMessage)
        }
        return response.json()
      })
      .then(result => {
        return dispatch(retrieveSidebarNav(result))
      })
  }
}

export function retrieveSidebarNav (result) {
  return {
    type: FETCH_SIDEBAR_NAV_FULFILLED,
    payload: result
  }
}

export function fetchAlertContent (fromServer = false) {
  const errorMessage = 'Bad response from server'
  let url = fromServer ? 'http://127.0.0.1:3000/helpfaq-assets/static/data/' : '/helpfaq-assets/static/data/'
  return dispatch => {
    return fetch(url + 'alert.json')
      .then(response => {
        if (response.status >= 400) {
          throw new Error(errorMessage)
        }
        return response.json()
      })
      .then(result => {
        return dispatch(retrieveAlertContent(result))
      })
  }
}

export function retrieveAlertContent (result) {
  return {
    type: FETCH_ALERT_CONTENT_FULFILLED,
    payload: result.message
  }
}
